import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IPerfil } from 'src/app/interfaces';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService, PerfilService } from 'src/app/services';
import { Subscription } from 'rxjs';
import { IToken } from 'src/app/interfaces/token/IToken';

@Component({
  selector: 'app-modal-editar-perfil',
  templateUrl: './modal-editar-perfil.component.html',
  styleUrls: ['./modal-editar-perfil.component.scss']
})
export class ModalEditarPerfilComponent implements OnInit, OnDestroy {
  @Output() updatePerfil = new EventEmitter();
  @ViewChild('modal') template: TemplateRef<any>;
  subscriptions$ = new Subscription();
  perfilEditar: IPerfil;
  editForm: FormGroup;
  token: IToken = this.authenticationService.obterToken();

  constructor(
    private fb: FormBuilder,
    private perfilService: PerfilService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.editForm = this.fb.group({
      nome: ['', [Validators.required]],
      descricao: ['', [Validators.required]]
    });
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }

  editarPerfil() {
    this.subscriptions$.add(
      this.perfilService
        .putPerfil({
          ...this.perfilEditar,
          idUsuario: this.token?.id,
          perfilId: this.perfilEditar.id,
          nome: this.editForm.get('nome')?.value,
          descricao: this.editForm.get('descricao')?.value
        })
        .subscribe({
          complete: () => {
            this.updatePerfil.emit();
            this.fecharModal();
          }
        })
    );
  }

  setForm(perfil: IPerfil) {
    this.editForm.setValue({
      nome: perfil.nome,
      descricao: perfil.descricao
    });
    this.perfilEditar = perfil;
  }

  abrirModal(perfil: IPerfil) {
    this.ngOnInit();
    this.modalService.open(this.template, {
      centered: true,
      size: 'lg'
    });
    this.setForm(perfil);
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  isButtonEnabled() {
    return (
      this.editForm.getRawValue().nome === this.perfilEditar.nome &&
      this.editForm.getRawValue().descricao === this.perfilEditar.descricao
    );
  }
}
